import { api } from "./client.js";

export const invitesApi = {
  preview: (code: string) =>
    api.get<{ valid: boolean; inviterName: string | null }>(
      `/api/invites/${encodeURIComponent(code)}`,
    ),
  create: (kind: "link" | "email" = "link") =>
    api.post<{ id: string; code: string; url: string }>("/api/invites", { kind }),
  redeem: (code: string) =>
    api.post<{ redeemed: boolean }>(`/api/invites/${encodeURIComponent(code)}/redeem`),
};
